import {useEffect, useState} from "react";
import Card from "../components/Card";
import CardContent from "../components/CardContent";
import api from "../api/axiosInstance";

export default function AdminCallbacksPage() {
    const [callbacks, setCallbacks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCallbacks = async () => {
            try {
                const res = await api.get("/callback/callbacks");
                setCallbacks(res.data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCallbacks();
    }, []);

    if (loading) {
        return <div className="p-6 text-sm">Loading callbacks…</div>;
    }

    if (error) {
        return <div className="p-6 text-sm text-red-600">{error}</div>;
    }

    return (
        <div className="p-6 space-y-4">
            <h1 className="text-xl font-semibold">Service Callbacks</h1>

            {callbacks?.length === 0 && (
                <div className="text-sm text-muted-foreground">No callbacks found.</div>
            )}

            <div className="grid gap-4">
                {callbacks?.map((cb) => (
                    <Card key={cb._id} className="rounded-2xl">
                        <CardContent className="p-4 space-y-2">
                            <div className="flex justify-between items-start">
                                <div>
                                    <div className="font-medium">Order: {cb.orderId}</div>
                                    <div className="text-sm text-muted-foreground">
                                        {cb.service} • {cb.stage}
                                    </div>
                                </div>
                                <div className="text-xs text-muted-foreground text-right">
                                    <div>Created: {new Date(cb.createdAt).toLocaleString()}</div>
                                    <div>Updated: {new Date(cb.updatedAt).toLocaleString()}</div>
                                </div>
                            </div>

                            {cb.issues?.length > 0 && (
                                <div className="text-sm">
                                    <div className="font-medium">Issues</div>
                                    <ul className="list-disc ml-5">
                                        {cb.issues.map((issue, idx) => (
                                            <li key={idx}>{issue}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {cb.details && Object.keys(cb.details).length > 0 && (
                                <details className="text-sm">
                                    <summary className="cursor-pointer font-medium">Details</summary>
                                    <pre className="mt-2 p-2 bg-muted rounded-xl overflow-auto text-xs">
                    {JSON.stringify(cb.details, null, 2)}
                  </pre>
                                </details>
                            )}

                            {cb.rawPayload?.length > 0 && (
                                <details className="text-sm">
                                    <summary className="cursor-pointer font-medium">Raw Payload</summary>
                                    <pre className="mt-2 p-2 bg-muted rounded-xl overflow-auto text-xs">
                    {JSON.stringify(cb.rawPayload, null, 2)}
                  </pre>
                                </details>
                            )}
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
}
